"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationListCustomerFilter = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const stable_1 = require("../../../CheckBox/stable");
const Field_1 = require("../../../Form/Field");
const stable_2 = require("../../../Form/Field/DateRange/stable");
const Filter_1 = require("../Filter");
require("../Filter/index.scss");
const ReservationListCustomerFilter = (props) => {
    const { field, } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: Filter_1.className },
        react_1.default.createElement("div", { className: `${Filter_1.className}__form` },
            react_1.default.createElement(Field_1.FormFieldStable, { ...field(['query']), placeholder: formatMessage({
                    id: 'components/Reservation/List:searchPlaceholder',
                    defaultMessage: 'Search',
                }), additionClassNames: `${Filter_1.className}__search`, prefixIcon: 'search' }),
            react_1.default.createElement(stable_1.CheckBoxStable, { ...field(['isActive']), textRight: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:IsActiveOnly', defaultMessage: 'Active only' }) })),
        react_1.default.createElement("div", { className: `${Filter_1.className}__form` },
            react_1.default.createElement(stable_2.FormFieldDateRangeStable, { ...field(['flightDateInterval']), additionClassNames: `${Filter_1.className}__range-dates`, fromField: {
                    ...field(['flightDateInterval', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:FlightFrom', defaultMessage: 'Flight from' })),
                }, toField: {
                    ...field(['flightDateInterval', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:FlightTo', defaultMessage: 'To' })),
                } }))));
};
exports.ReservationListCustomerFilter = ReservationListCustomerFilter;
//# sourceMappingURL=index.js.map